import UIDs from "../../../../UIDs";

const uid = UIDs.components.chinesepark.spokenBooksModal;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    LOAD_SECTIONS_ASYNC: `${uid}.loadSectionsAsync`,
    LOAD_SECTIONS_SUCCESS: `${uid}.loadSectionsSuccess`,
    LOAD_SECTIONS_FAILURE: `${uid}.loadSectionsFailure`,
    LOAD_UNITS_ASYNC: `${uid}.loadUnitsAsync`,
    LOAD_UNITS_SUCCESS: `${uid}.loadUnitsSuccess`,
    LOAD_UNITS_FAILURE: `${uid}.loadUnitsFailure`,
    SELECT_COURSE_TYPE: `${uid}.selectCourseType`,
    SELECT_COURSE: `${uid}.selectCourse`,
    SELECT_SECTION: `${uid}.selectSection`,
    SELECT_UNIT: `${uid}.selectUnit`,
};

export { ActionTypes };
